import { FC, useMemo } from 'react';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@features/ui';
import { EllipsisVerticalIcon } from 'lucide-react';
import { BillingActionData } from '@features/user/billing/billingData.ts';
import { BillingActionType, BillingStatus } from '@src/types/billing.ts';

interface DropdownActionProps {
  status?: BillingStatus;
  onSelect?: (value: BillingActionType) => void;
}

export const DropdownAction: FC<DropdownActionProps> = ({
  onSelect,
  status,
}) => {
  const isCancel = useMemo(
    () => status === BillingStatus.Canceled || status === BillingStatus.Expired,
    [status]
  );
  const isActive = useMemo(() => status === BillingStatus.Active, [status]);

  const data = useMemo(() => {
    if (isActive) {
      return BillingActionData.filter(
        (item) => item.value !== BillingActionType.Renew
      );
    }
    if (isCancel) {
      return BillingActionData.filter(
        (item) => item.value !== BillingActionType.Canceled
      );
    }

    return BillingActionData;
  }, [isActive, isCancel]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className={'[&_svg]:!size-auto hover:text-white'}
          variant={'ghost'}
        >
          <EllipsisVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className={'bg-[#414141]'}>
        {data.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onSelect={() => onSelect?.(option.value as BillingActionType)}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
